<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { clickOutside } from '../../utilities/clickOutside';

    export let isOpen: boolean = false;
    export let statusMessage: string = '';
    export let errors: string[] = [];
    export let warnings: string[] = [];
    export let planId: number | null = null;
    export let onOpenPlan: (planId: number) => void = () => {};

    $: hasErrors = errors.length > 0;

    function openPlan() {
        closeModal();
        if (planId !== null) {
            onOpenPlan(planId);
        }
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal" use:clickOutside on:click_outside={closeModal}>
        <div class="contents" class:has-errors={hasErrors} data-testid="tactical-plan-json-import-result">
            <div class="status" class:error={hasErrors} class:success={!hasErrors}>
                {statusMessage}
            </div>
            {#if errors.length > 0}
                <div class="list errors">
                    <strong>{$_('tp_import_json_errors_label')}</strong>
                    <ul>
                        {#each errors as message}
                            <li>{message}</li>
                        {/each}
                    </ul>
                </div>
            {/if}
            {#if warnings.length > 0}
                <div class="list warnings">
                    <strong>{$_('tp_import_json_warnings_label')}</strong>
                    <ul>
                        {#each warnings as message}
                            <li>{message}</li>
                        {/each}
                    </ul>
                </div>
            {/if}
            <div class="actions">
                {#if planId !== null}
                    <ButtonMain text={$_('tp_import_json_open_plan')} on:click={openPlan} />
                {/if}
                <ButtonMain text={$_('OK')} on:click={closeModal} />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;
        pointer-events: none;
    }

    .contents {
        min-width: 390px;
        max-width: 640px;
        max-height: 80vh;
        overflow-y: auto;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid var(--automapa-blue);
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
        row-gap: 8px;
    }

    .contents.has-errors {
        border-color: #d45659;
        box-shadow:
            0 0 0 10px #d93b4d44,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .status.success {
        color: #2e7d32;
        text-align: center;
    }

    .status.error {
        color: #d32f2f;
    }

    .list {
        font-size: 12px;
        margin-top: 4px;
    }

    .list ul {
        margin: 4px 0 0 16px;
        padding: 0;
    }

    .errors li {
        color: #d32f2f;
    }

    .warnings li {
        color: #8a5a00;
    }

    .actions {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        gap: 10px;
    }
</style>
